var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinOriginalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.3 107.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007bbc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82,58.16v20a.89.89,0,0,1-.9.89H70.78a.89.89,0,0,1-.89-.89V59.56c0-4.89-1.75-8.24-6.14-8.24a6.62,6.62,0,0,0-6.21,4.43,8.29,8.29,0,0,0-.4,3V78.16a.89.89,0,0,1-.9.89H45.92a.88.88,0,0,1-.89-.89c0-5,.12-29,0-34.63a.89.89,0,0,1,.89-.91h10.3a.9.9,0,0,1,.9.9v4.26a.83.83,0,0,0-.08.12h.08v-.12a12,12,0,0,1,10.91-6c8,0,14,5.2,14,16.39ZM27.11,79.05H37.43a.89.89,0,0,0,.89-.89V43.52a.89.89,0,0,0-.89-.9H27.11a.9.9,0,0,0-.9.9V78.16A.89.89,0,0,0,27.11,79.05Z",
    id: "id_106"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.91,
    cy: 31.5,
    r: 6.48,
    id: "id_107"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.49,6.89a11.94,11.94,0,0,1,11.92,11.92V88.49a11.94,11.94,0,0,1-11.92,11.92H18.81A11.94,11.94,0,0,1,6.89,88.49V18.81A11.94,11.94,0,0,1,18.81,6.89H88.49m0-6.89H18.81A18.81,18.81,0,0,0,0,18.81V88.49A18.81,18.81,0,0,0,18.81,107.3H88.49A18.81,18.81,0,0,0,107.3,88.49V18.81A18.81,18.81,0,0,0,88.49,0Z",
    id: "id_108"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinOriginalIcon);
export default __webpack_public_path__ + "static/media/linkedin-original-icon.1fdfb611a666aa6b1fcbe1035de34763.svg";
export { ForwardRef as ReactComponent };